import styled, { css } from 'styled-components'

export const StyledModalContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px;
  z-index: 100;
`

export const Dimmed = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.8;
`

export const StyledWrapper = styled.div`
  position: relative;
  max-width: 280px;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.4);
  border: 1px solid #efefef;
  border-radius: 8px;
`

export const StyledFormModalWrapper = styled(StyledWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: 450px;
  height: 100%;
  max-width: 320px;
`

export const StyledContent = styled.div<{ title?: string }>`
  display: flex;
  align-items: center;
  padding: 10px 20px;
  ${({ title }) => title && 'flex-direction: column; align-items: flex-start;'};
`

export const StyledTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 125%;
`

export const StyledText = styled.div<{ title?: string }>`
  ${({ title }) => css`
    width: 100%;
    font-size: ${title ? '13px' : '16px'};
    ${!title && 'font-weight: 700; text-align: center;'};
    white-space: pre-wrap;
  `}
`
export const StyledButtons = styled.div`
  display: flex;
  width: 100%;
  height: 58px;
  border-top: 1px solid #dfdfdf;

  & > button {
    width: 100%;
    height: 100%;
    border-radius: unset;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
    border: none;
    background: transparent;
  }
`

export const StyledButtonCancel = styled.button`
  border-right: 1px solid #dde0e2 !important;
`
export const StyledFormTitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;

  & button {
    border: none;
    background: transparent;
  }
`
export const StyledFormContent = styled.div`
  font-size: 12px;
  line-height: 1.5;
  width: 100%;
`
export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  gap: 12px 0;
`
export const StyledGuideText = styled.span`
  display: block;
  margin-top: 8px;
  letter-spacing: -0.5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 125%; /* 15px */
  color: var(--color-grey-400, #999);
`
export const StyledFormCheckBoxContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0;

  input[type='checkbox'] + label {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-right: 2px;
    i:first-of-type {
      display: block;
    }
    i:last-of-type {
      display: none;
    }
  }

  input[type='checkbox']:checked + label {
    i:first-of-type {
      display: none;
    }
    i:last-of-type {
      display: block;
    }
  }

  input[type='checkbox'] {
    display: none;
  }
`
export const StyledFormCheckBoxLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const StyledFormCheckBoxLabelText = styled.p`
  display: flex;
  align-items: center;
  margin: 0 0 0 6px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%; /* 17.5px */

  strong {
    color: var(--Player-States-danger-dager-500, #ff3d33);
    font-weight: 400;
  }

  span {
    margin-left: 4px;
    color: var(--Player-Palette-Grey-grey-900, #333);
  }
`

export const StyledInput = styled.input<{ error?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px;
  border: ${({ error }) => (error ? '1px solid #ff2d55' : '1px solid #cdd1d4')};
  border-radius: 4px;
  font-size: 12px;
`

export const StyledErrorMessage = styled.span`
  font-size: 12px;
  letter-spacing: -0.5px;
  line-height: 1.5;
  color: #ff2d55;
`

export const StyledFormSubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  margin: 0 20px 10px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  color: #fff !important;
  background: #ff2d55;

  &:disabled {
    background: #cdd1d4;
  }
`

export const StyledAnchor = styled.a`
  margin-left: 8px;
  color: var(--Player-Palette-Grey-grey-900, #333);
  font-size: 12px;
  font-weight: 700;
  line-height: 125%; /* 15px */
`

export const StyledTermModalContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px;
  z-index: 1000;
`

export const TermDimmed = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.2;
`

export const StyledTermButton = styled.button`
  background: none;
  border: none;
  box-shadow: none;
  border-radius: 0;
  padding: 0;
  overflow: visible;
  cursor: pointer;
`

export const StyledTermHeader = styled.div`
  display: flex;
  & button {
    z-index: 9999;
    border: none;
    background: transparent;
    position: absolute;
    right: 16px;
    top: 18px;
  }
`

export const StyledTermImageContainer = styled.div`
  width: 100%;
  height: 400px;
  overflow-y: auto;
`

export const StyledTermImage = styled.img`
  width: 100%;
  display: block;
`
